import { ERecouvrement } from "./enum/recouvrement";

export class IBMREclairement {
    TresOmbrage: ERecouvrement = ERecouvrement.Absent;
    Ombrage: ERecouvrement = ERecouvrement.Absent;
    PeuOmbrage: ERecouvrement = ERecouvrement.Absent;
    Eclaire: ERecouvrement = ERecouvrement.Absent;
    TresEclaire: ERecouvrement = ERecouvrement.Absent;

    static mapFromJSON(json): IBMREclairement {
        const e = new IBMREclairement();

        e.TresOmbrage = json.tresOmbrage;
        e.Ombrage = json.ombrage;
        e.PeuOmbrage = json.peuOmbrage;
        e.Eclaire = json.eclaire;
        e.TresEclaire = json.tresEclaire;

        return e;
    }
}